import user from './user'
import { combineReducers } from 'redux'

export default combineReducers({
    user
})


// WEBPACK FOOTER //
// ./src/reducers/index.js